import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ScrollEffect from "../../effects/ScrollEffect";
import { TableFooter } from "@mui/material";

export default function TableNoSelect({ headers, rows }) {
  return (
    <TableContainer component={Paper}>
      <ScrollEffect width="100%" height="390px">
        <Table
          sx={{ minWidth: 750, height: "100%" }}
          aria-labelledby="Excel upload"
          size="small"
          padding="checkbox"
          stickyHeader
        >
          <TableHead sx={{ height: "100%" }}>
            <TableRow sx={{ height: "100%" }}>
              {headers.map((h, index) => (
                <TableCell key={`${h}-${index}`} sx={{ height: "100%" }}>
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ marginTop: "10px" }}>
            {rows.map((row, index) => (
              <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                {Object.keys(row).map((key) => (
                  <TableCell key={key + index}>{row[key]}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
          <TableFooter sx={{ height: "20px" }}></TableFooter>
        </Table>
      </ScrollEffect>
    </TableContainer>
  );
}
